/*
 *
 * LanguageProvider
 *
 * this component connects the redux state language locale to the
 * IntlProvider component and i18n messages (loaded from `app/translations`)
 */

import React from 'react'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import { IntlProvider } from 'react-intl'

import { makeSelectLocale } from './selectors'

interface LanguageProviderProps {
  locale: string
  messages: Record<string, any>
  children: React.ReactElement
}

export function LanguageProvider(props: LanguageProviderProps) {
  return (
    <IntlProvider locale={props.locale} key={props.locale} messages={props.messages[props.locale]}>
      {React.Children.only(props.children)}
    </IntlProvider>
  )
}

const mapStateToProps = createSelector(makeSelectLocale(), locale => ({
  locale,
}))

function mapDispatchToProps(dispatch: any) {
  return {
    dispatch,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LanguageProvider)

